import { createContext, ReactNode } from 'react';

import { IProductTemplate } from 'shared/types/ProductTemplate';

interface IProductTemplateProviderProps {
  children: ReactNode;
  productTemplate: IProductTemplate;
}

export const ProductTemplateContext = createContext<IProductTemplate>(null);

export const ProductTemplateProvider = ({
  children,
  productTemplate,
}: IProductTemplateProviderProps) => {
  return (
    <ProductTemplateContext.Provider value={productTemplate}>
      {children}
    </ProductTemplateContext.Provider>
  );
};
